import TouchIndicator from './TouchIndicator'

export default TouchIndicator
